var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article-container"},[(!_vm.showEmptyImg)?_c('ArticleDetail',{staticClass:"article-info",attrs:{"article-info":_vm.articleInfo}}):_c('div',{staticClass:"no-article"},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('k_1214293')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }